module.exports = __webpack_public_path__ + "static/media/110.ccde80b7.svg";